// Import model
import { DataviewRoomPhotoFileResponse } from '../models/DataviewRoomPhotoFileResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterRoomPhotoFileRequest } from '../models/FilterRoomPhotoFileRequest';
import { RoomPhotoFile } from '../models/RoomPhotoFile';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterRoomPhotoFileRequestSerializer } from './FilterRoomPhotoFileRequestSerializer';
import { RoomPhotoFileSerializer } from './RoomPhotoFileSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewRoomPhotoFileResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewRoomPhotoFileResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewRoomPhotoFileResponse instance
   */
  static deserialize(json: string): DataviewRoomPhotoFileResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewRoomPhotoFileResponse instance
   */
  static fromObject(obj: any): DataviewRoomPhotoFileResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewRoomPhotoFileResponse');
    }


    const instance: DataviewRoomPhotoFileResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        RoomPhotoFileSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterRoomPhotoFileRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewRoomPhotoFileResponse instances
   */
  static deserializeArray(json: string): DataviewRoomPhotoFileResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewRoomPhotoFileResponse instance to a JSON string
   */
  static serialize(instance: DataviewRoomPhotoFileResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewRoomPhotoFileResponse instance to a plain object
   */
  static toObject(instance: DataviewRoomPhotoFileResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        RoomPhotoFileSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterRoomPhotoFileRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewRoomPhotoFileResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewRoomPhotoFileResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
